var map = {
	"./accordItem1.png": 9769,
	"./accounts.svg": 43,
	"./advantage.svg": 7682,
	"./arrow-left.svg": 2600,
	"./arrow-right-black.svg": 3089,
	"./arrow-right.svg": 7095,
	"./asan.png": 9870,
	"./authorization.svg": 5494,
	"./building.svg": 9595,
	"./burger-menu.svg": 2692,
	"./business-card-order.svg": 511,
	"./business-cards-income.svg": 2513,
	"./card-account-statement.svg": 8983,
	"./card-extension.svg": 6161,
	"./card-transfers.svg": 9322,
	"./cards-closing.svg": 554,
	"./chat.svg": 7333,
	"./checked.svg": 2022,
	"./close.svg": 7733,
	"./comission.svg": 2561,
	"./copy.svg": 5072,
	"./currency-exchange.svg": 2616,
	"./download-icon.svg": 8723,
	"./download-white.svg": 2892,
	"./e-commerce.svg": 3136,
	"./email.svg": 2665,
	"./faq-header.png": 5457,
	"./faq.png": 9011,
	"./feedback.svg": 4050,
	"./file.svg": 5581,
	"./foreign-currency-transfers.svg": 2040,
	"./free-join.png": 4140,
	"./free.png": 713,
	"./get-api-error.png": 8021,
	"./get-api-success.png": 1470,
	"./getapi.png": 3719,
	"./how-to-use.png": 6337,
	"./info-circle.svg": 3784,
	"./info.png": 8623,
	"./integration.png": 2261,
	"./internal-transfers.svg": 8411,
	"./international-transfers.svg": 9606,
	"./intro-video-cover.png": 6189,
	"./loading.svg": 9097,
	"./logo.png": 2806,
	"./main-logo.svg": 5700,
	"./minus.svg": 6993,
	"./mobile-input.svg": 8706,
	"./modern.png": 5086,
	"./national-currency-transfers.svg": 6804,
	"./not-language.jpg": 3065,
	"./online.png": 5530,
	"./phone.svg": 7233,
	"./pin-lock.png": 2728,
	"./pin-lock.svg": 9896,
	"./play-icon.svg": 5473,
	"./plus.svg": 1363,
	"./pos-info.svg": 5836,
	"./products-header.png": 2885,
	"./question.png": 4591,
	"./question.svg": 5275,
	"./receiving-card-info.svg": 4935,
	"./responsive-logo.svg": 8043,
	"./right-arrow-how-it-works.svg": 6261,
	"./right-arrow.svg": 3311,
	"./security.png": 6177,
	"./settings.svg": 4756,
	"./share.svg": 6060,
	"./slider1-bank.png": 8507,
	"./slider1-innovation.png": 5635,
	"./slider1-integration.png": 5202,
	"./slider1.png": 9767,
	"./slider2.png": 9132,
	"./slider3.png": 8549,
	"./soon.png": 3826,
	"./success-test-apply.png": 2874,
	"./support-success.png": 3448,
	"./support-usage1-AZ.png": 3971,
	"./support-usage1-EN.png": 7235,
	"./support-usage1-RU.png": 521,
	"./support-usage2-AZ.png": 7270,
	"./support-usage2-EN.png": 8014,
	"./support-usage2-RU.png": 908,
	"./support.png": 870,
	"./taxNo.svg": 4599,
	"./tooltip.svg": 356,
	"./usage-getapi-asan.jpg": 5245,
	"./usage-getapi-notuser.jpg": 9188,
	"./usage-getapi-pin1-AZ.png": 4496,
	"./usage-getapi-pin1-EN.png": 6456,
	"./usage-getapi-pin1-RU.png": 4438,
	"./usage-getapi-pin2-AZ.png": 7881,
	"./usage-getapi-pin2-EN.png": 1201,
	"./usage-getapi-pin2-RU.png": 1151,
	"./usage-getapi-result-AZ.png": 3555,
	"./usage-getapi-result-EN.png": 1392,
	"./usage-getapi-result-RU.png": 8201,
	"./usage-getapi1-AZ.png": 3066,
	"./usage-getapi1-EN.png": 2,
	"./usage-getapi1-RU.png": 3480,
	"./usage-getapi2-AZ.png": 7719,
	"./usage-getapi2-EN.png": 4231,
	"./usage-getapi2-RU.png": 5317,
	"./usage-getapi3-AZ.png": 7228,
	"./usage-getapi3-EN.png": 1476,
	"./usage-getapi3-RU.png": 4138,
	"./usage-getapi4-AZ.png": 6033,
	"./usage-getapi4-EN.png": 2601,
	"./usage-getapi4-RU.png": 7607,
	"./usage-info1-AZ.png": 3930,
	"./usage-info1-EN.png": 1842,
	"./usage-info1-RU.png": 3608,
	"./usage-info2-AZ.png": 7351,
	"./usage-info2-EN.png": 6839,
	"./usage-info2-RU.png": 4021,
	"./usage-partner1-AZ.png": 7592,
	"./usage-partner1-EN.png": 3520,
	"./usage-partner1-RU.png": 2126,
	"./usage-partner2-AZ.png": 8513,
	"./usage-partner2-EN.png": 1433,
	"./usage-partner2-RU.png": 6439,
	"./usage-partner3-AZ.png": 454,
	"./usage-partner3-EN.png": 1310,
	"./usage-partner3-RU.png": 9500,
	"./usage-test1-AZ.png": 7122,
	"./usage-test1-EN.png": 3034,
	"./usage-test1-RU.png": 768,
	"./usage-test2-AZ.png": 9695,
	"./usage-test2-EN.png": 3503,
	"./usage-test2-RU.png": 4637,
	"./usage-test3-AZ.png": 6660,
	"./usage-test3-EN.png": 4940,
	"./usage-test3-RU.png": 5554,
	"./usage.png": 9190,
	"./user-input.svg": 8181,
	"./white-logo.svg": 1958
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;